namespace SorAraBul.Membership {

    @Serenity.Decorators.registerClass()
    export class ProfileUpdatePanel extends Serenity.PropertyPanel<ProfileUpdateRequest, ProfileUpdateRequest> {

        protected getFormKey() { return ProfileUpdateForm.formKey; }

        private form: ProfileUpdateForm;

        constructor(container: JQuery, entity?: ProfileUpdateRequest) {
            super(container, entity);

            this.form = new ProfileUpdateForm(this.idPrefix);

            if (entity) {
                this.form.MobilePhoneNumber.value = entity.MobilePhoneNumber || '';
                this.form.InvoiceAddress.value = entity.InvoiceAddress || '';
            }

            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }

                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/ProfileUpdate'),
                    request: this.getSaveEntity(),
                    onSuccess: response => {
                        Q.information(Q.text('Forms.Membership.ProfileUpdate.Success'), () => {
                            window.location.href = Q.resolveUrl('~/Dashboard');
                        });
                    }
                });
            });
        }

        getTemplate() {
            return `<div class="s-Panel">
    <h3 class="page-title mb-4 text-center">${Q.text("Forms.Membership.ProfileUpdate.FormTitle")}</h3>
    <form id="~_Form" action="">
        <div id="~_PropertyGrid"></div>
        <div class="px-field mt-4">
            <button id="~_SubmitButton" type="submit" class="btn btn-primary w-100">
                ${Q.text("Forms.Membership.ProfileUpdate.SubmitButton")}
            </button>
        </div>
    </form>
</div>`;
        }
    }
}
